import { Alert } from '../../contexts/ApplicationSuiteProvider'

export type AlertFormSettings = {
  symbolDisabled: boolean
  patternDisabled: boolean
  dayCheckmark: boolean
  /**
   * Force-unlocks the symbol picker, overriding both `symbolDisabled` and the
   * `from === 'backtest'` origin lock.
   *
   * Used by the duplicate flow: a duplicate is a brand-new alert that has never
   * run, so retargeting it to a different symbol is always safe — including when
   * it inherits `from: 'backtest'` attribution from its source. This flag must
   * therefore OVERRIDE the origin check, not be AND-ed with it.
   */
  allowSymbolChange?: boolean
}

export function isSymbolSelectionDisabled(
  alert: Pick<Alert, 'from'>,
  settings?: AlertFormSettings
): boolean {
  if (settings?.allowSymbolChange) return false
  return alert.from === 'backtest' || !!settings?.symbolDisabled
}
